export default {
  tabs: {
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    fontFamily: 'Avenir Next LT Pro',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'left',
    height: '100%'
  },
  indicator: {
    background: 'transparent'
  },
  tab: {
    textAlign: 'left',
    fontSize: 16,
    '&:hover': {
      background: '#4E5360',
      color: '#F5F6FA'
    },
    '&> span': {
      alignItems: 'end'
    }
  },
  gridContainer: {
    height: '100%'
  }
};
